import React from "react";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { AnalyticsExportMenu } from "../shared/AnalyticsExportMenu";
import { AnalyticsServicesFilterPopover } from "./AnalyticsServicesFilterPopover";
import type { ServiceCategoryFilterOption } from "./topServicesListQuery";
import type { TopServicesFiltersState } from "./topServicesFilters";

interface ServicesAllListToolbarProps {
  appliedFilters: TopServicesFiltersState;
  onFiltersApply: (next: TopServicesFiltersState) => void;
  categoryOptions: ServiceCategoryFilterOption[];
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  onExport: (format: "csv" | "xlsx") => void;
  isExportDisabled?: boolean;
  isExporting?: boolean;
}

export const ServicesAllListToolbar: React.FC<ServicesAllListToolbarProps> = ({
  appliedFilters,
  onFiltersApply,
  categoryOptions,
  searchQuery,
  onSearchQueryChange,
  onExport,
  isExportDisabled = false,
  isExporting = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center gap-3">
      <AnalyticsServicesFilterPopover
        applied={appliedFilters}
        onApply={onFiltersApply}
        categoryOptions={categoryOptions}
      />

      <div className="min-w-[200px] max-w-md flex-1">
        <Input
          type="search"
          value={searchQuery}
          onChange={(event) => onSearchQueryChange(event.target.value)}
          placeholder={t("analytics.common.search", "Search")}
          icon={<Search className="size-4 text-[#737373]" aria-hidden />}
          className="h-8"
        />
      </div>

      <AnalyticsExportMenu
        className="ml-auto h-8 min-h-8 shrink-0 gap-2 border border-slate-200 py-1 text-sm font-medium text-foreground shadow-xs"
        onExport={onExport}
        disabled={isExportDisabled || isExporting}
      />
    </div>
  );
};
